import { createStore } from '@mpxjs/core'

const store = createStore({
  state: {
    // 主要是小程序内嵌h5判断，
    from: '',
    channelId: '00000',
    appVersion: '',
    clientType: '',
    terminal: '',
    lang: 'zh-CN',
    openid: '',
    userInfo: {},
    cityInfo: {
      cityId: 0,
      cityName: '',
      lat: '',
      lng: '',
    },
    eventParams: {},
    dchn: '',
    atDidao: false,
    apolloData: {},
  },
  getters: {
    channelId: state => state.channelId,
    from: state => state.from,
    clientType: state => state.clientType,
    appVersion: state => state.appVersion,
    userInfo: state => state.userInfo,
    cityInfo: state => state.cityInfo,
    eventParams: state => state.eventParams,
    lang: state => state.lang,
    openid: state => state.openid,
    terminal: state => state.terminal,
    dchn: state => state.dchn,
    atDidao: state => state.atDidao,
    apolloData: state => state.apolloData,
  },
  actions: {},
  mutations: {
    setChannelId(state, channelId) {
      state.channelId = channelId
    },
    setFrom(state, from) {
      state.from = from
    },
    setClientType(state, clientType) {
      state.clientType = clientType
    },
    setTerminal(state, terminal) {
      state.terminal = terminal
    },
    setAppVersion(state, appVersion) {
      state.appVersion = appVersion
    },
    setLang(state, lang) {
      state.lang = lang
    },
    setOpenId(state, openid) {
      state.openid = openid
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setCityInfo(state, cityInfo) {
      if (cityInfo.cityId === state.cityInfo.cityId) {
        state.cityInfo = Object.assign(state.cityInfo, cityInfo)
      } else {
        state.cityInfo = cityInfo
      }
    },
    setEventParams(state, eventParams) {
      state.eventParams = eventParams
    },
    setDchn(state, dchn) {
      state.dchn = dchn
    },
    setDidao(state, didao) {
      state.atDidao = didao
    },
    setApolloData(state, apolloData) {
      state.apolloData = apolloData
    },
  },
})

// eslint-disable-next-line import/no-default-export
export default store
